import { createAction } from "redux-actions";
import { mockApiCall } from "../../services/settings";

export enum ACTIONS {
	MOCK_ACTION = "SETTINGS/MOCK_ACTION",
}

export const mockAction = createAction(ACTIONS.MOCK_ACTION, mockApiCall);
